import { SetStateAction } from "react";
import { colors } from "../../../data/colors";
import { stdObject } from "../../../data/types/stdObject";
import { stationeryOptions } from "../../MainStructure/SearchBar/data/searchItemUtils";

export const cloneStationeryModal = ({
  t,
  windowValues,
  closeMsg,
  modalData,
  startCloneStationery,
  updateStaList,
  setWindowValues,
}: stdObject) => {
  return "staData" in windowValues
    ? {
        title: modalData.title,
        label: modalData.label,
        mainColor: modalData.mainColor,
        inputs: ["document", "code"].map((e: string) => {
          return {
            label: t(`p.${e}`),
            value: windowValues.staData[e],
            type: "select",
            options: [
              { value: "" },
              ...(e === "document"
                ? stationeryOptions
                : windowValues.staData.list
              ).map((e: stdObject) => {
                return { ...e, label: t(e.label) };
              }),
            ],
            onChange: async (v: {
              target: { value: SetStateAction<string> };
            }) => {
              let tempValues = windowValues;
              tempValues.staData[e] = v.target.value;
              if (e === "document") {
                tempValues.staData.list =
                  v.target.value === ""
                    ? []
                    : await updateStaList(v.target.value as string);
              }
              setWindowValues({ ...tempValues });
            },
          };
        }),
        buttons: [
          {
            label: t("p.copy"),
            onClick: startCloneStationery,
            color: colors.green,
          },
          {
            label: t("p.cancel"),
            onClick: closeMsg,
            color: colors.darkGrey,
          },
        ],
      }
    : {};
};
